import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/payroll/list', data, {params})
  },
  listAll() {
    return http.get('/payroll')
  },
  changeStatus(id, status) {
    return http.put(`/payroll/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/payroll', data)
  },
  update(id, data) {
    return http.put(`/payroll/${id}`, data)
  },
  get(id) {
    return http.get(`/payroll/${id}`)
  },
  queryDni(dni) {
    return http.get(`/payroll/dni/${dni}`)
  },
  download(data) {
    return http.post("/payroll/xlsx", data, { responseType: "blob" });
  }
}
